(function () {
    'use strict';

    angular
        .module('app.tags')
        .controller('TagsEditController', EditController);

    EditController.$inject = ['$location', '$stateParams', 'TagsService'];

    function EditController($location, $stateParams, Service) {
        /* jshint validthis:true */
        var vm = this;

        vm.loading = true;
        vm.title = '';

        Service.get($stateParams.Id).then(function (data) {
            vm.entity = data;
            vm.loading = false;
        });

        vm.fields = Service.getFields();

        vm.edit = function () {
            if (vm.form.$valid) {
                vm.loading = true;
                vm.entity.Media = null;
                Service.edit(vm.entity).then(function () {
                    vm.loading = false;
                    $location.path('/tags/detail/' + vm.entity.Id);
                });
            }
        };

        vm.cancel = function () {
            $location.path('/tags/detail/' + vm.entity.Id);
        };
    }
})();